<template>
	<div class="courseinfm_wrap" :style="'height:'+height">
		<div class="course_cont">
			<div class="course">
				<div class="course_left">
					<img :src="courseParam.courseLogo?courseParam.courseLogo:courseDefPic"/>
				</div>
				<div class="course_right">
					<h3>{{$route.query.courseName}}</h3>
					<div class="icons">
						<div class="hour icons-item">
							<img src="../../../../../static/images/course/teachClassIcon/classHour.png"/>
							<span>课时：{{courseParam.courseHour}}</span>
						</div>
						<div class="business icons-item">
							<img src="../../../../../static/images/course/teachClassIcon/task-sm.png"/>
							<span>任务数量：{{courseParam.taskNum}}</span>
						</div>
					</div>
					<p>课程简介：{{courseMsg.courseContext}}</p>
				</div>
			</div>
		</div>
		<div class="title_wrap">
			<i></i>岗位介绍
		</div>
		<div class="jobDescription">
			<li v-for="(item,index) in postList" :key="index">
				<div class="top_title">
					<img :src="handleImgShow(index)"/>
					<span>{{item.name}}</span>
				</div>
				<div class="bottom">
					<div :class="item.remark?'cont':'middle'">
						{{item.remark?item.remark:'暂无介绍'}}
					</div>
				</div>
			</li>
		</div>
		<div class="title_wrap">
			<i></i>课程详情
		</div>
		<div class="course_detail" v-html="courseMsg.detail">
			
		</div>
	</div>
</template>

<script>
	import * as api from "../../../../api/individualApi";
	export default {
		data(){
			return {
				height:window.innerHeight - 236+"px",
				courseParam:{
					courseHour:'',
					taskNum:'',
					courseLogo:''
				},
				courseDefPic: '/static/images/newCourse/courseCover/cover1.png',
				courseMsg: JSON.parse(sessionStorage.getItem('courseMsg')),
				postList:[],
				productFlag: sessionStorage.getItem('productFlag'),
				prodId: sessionStorage.getItem('prodId')
			}
		},
		created(){
			this.getCourseMsg();
			this.getPostIntroduce();
		},
		methods: {
			getCourseMsg(){
				api.getCourseMsg(this.$route.query.courseId).then(res=>{
					if(res.code == 0){
						this.courseParam.taskNum = res.data.taskNum;
						this.getTeachCourse();
					}
				})
			},
			getTeachCourse(){
				let obj = {
					"type": this.productFlag,
					"courseType": this.productFlag==4?4:3,
					"courseProfessional": sessionStorage.getItem('professional'),
					"courseName": "",
					"prodId": this.prodId
				};
				api.getTeachCourse(obj).then(res=>{
					if(res.code == 0){
						let arr = res.data;
						let courseId = this.$route.query.courseId;
						arr.forEach(val=>{
							if(courseId == val.id){
								this.courseParam.courseHour = val.courseHour;
								this.courseParam.courseLogo = val.courseLogo;
							}
						})
					}
				})
			},
			// 获取岗位介绍
			getPostIntroduce(){
				api.getPostIntroduce(this.$route.query.subjectId).then(res=>{
					// console.log(res);
					if(res.code == 0){
						this.postList = res.data;
					}
				})
			},
			// 处理图片显示
			handleImgShow(index){
				let imgUrl = '';
				switch (index){
					case 0:
						imgUrl = '../../../../../static/images/course/teachClassIcon/bg1.png'
						break;
					case 1:
						imgUrl = '../../../../../static/images/course/teachClassIcon/bg2.png'
						break;
					case 2:
						imgUrl = '../../../../../static/images/course/teachClassIcon/bg3.png'
						break;
					case 3:
						imgUrl = '../../../../../static/images/course/teachClassIcon/bg4.png'
						break;
					case 4:
						imgUrl = '../../../../../static/images/course/teachClassIcon/bg1.png'
						break;
					case 5:
						imgUrl = '../../../../../static/images/course/teachClassIcon/bg2.png'
						break;
					case 6:
						imgUrl = '../../../../../static/images/course/teachClassIcon/bg3.png'
						break;
					case 7:
						imgUrl = '../../../../../static/images/course/teachClassIcon/bg4.png'
						break;
					default:
						break;
				}
				return imgUrl;
			}
		}
	}
</script>

<style scoped lang="scss">
	.courseinfm_wrap {
		background: #fff;
		overflow-y: auto;
		overflow-x: hidden;
		.title_wrap {
			padding-left: 10px;
			display: flex;
			justify-content: flex-start;
			align-items: center;
			font-size: 16px;
			margin-bottom: 16px;
			color: #0D141E;
			i {
				display: inline-block;
				width: 6px;
				height: 16px;
				background: #5397F7;
				margin-right: 5px;
			}
		}
		.course_cont {
			display: flex;
			justify-content: space-around;
			height: 160px;
			margin-bottom: 10px;
			.course {
				width: 100%;
				height: 100%;
				background: #fff;
				display: flex;
				align-items: center;
				justify-content: space-between;
				.course_left {
					width: 240px;
					height: 136px;
					img {
						display: block;
						width: 100%;
						height: 100%;
						border-radius: 8px;
					}
				}
				.course_right {
					width: calc(100% - 280px);
					h3 {
						font-size: 16px;
						color: #0D141E;
						font-family:Hiragino Sans GB;
						margin-bottom: 13px;
						i {
							display: inline-block;
							width: 44px;
							height: 18px;
							font-size: 12px;
							color: #fff;
							background: #fbaa00;
							border-radius: 2px;
							line-height: 18px;
							text-align: center;
							margin-right: 3px;
						}
					}
					p {
						font-size: 12px;
						color: #5D646E;
						margin: 20px 0;
						height: 43px;
						overflow: hidden;
						display: -webkit-box;
						-webkit-line-clamp: 2;
						-webkit-box-orient: vertical;
						line-height: 20px;
					}
				}
				.icons {
					display: flex;
					justify-content: flex-start;
					align-items: center;
					.icons-item {
						display: flex;
						align-items: center;
						margin-right: 100px;
						width: 150px;
					}
					img {
						display: inline-block;
						width: 18px;
						height: 18px;
						margin-right: 10px;
					}
					span {
						font-size: 14px;
						color: #0D141E;
					}
				}
			}
		}
		.jobDescription {
			margin-top: 23px;
			padding-bottom: 10px;
			margin-bottom: 28px;
			overflow-x: scroll;
			display: flex;
			li {
				width: 278px;
				height: 243px;
				border-radius: 4px;
				border: 1px solid #DDE0E2;
				margin-right: 50px;
				border-top: 0;
				border-left: 0;
				border-right: 0;
				flex: none;
				&:last-child{
					margin-right: 0;
				}
				.top_title {
					position: relative;
					line-height: 64px;
					height: 64px;
					span {
						position: absolute;
						width: 100%;
						color: #fff;
						font-size: 16px;
						top: 0;
						left: 0;
						text-align: center;
					}
					img {
						display: block;
						width: 100%;
						height: 100%;
						border-radius: 4px 4px 0 0;
					}
				}
				.bottom {
					font-size: 12px;
					color: #5D646E;
					line-height: 20px;
					height: 179px;
					border-left: 1px solid #DDE0E2;
					border-right: 1px solid #DDE0E2;
					.cont {
						padding: 21px;
						display: -webkit-box;
						-webkit-line-clamp: 7;
						-webkit-box-orient: vertical;
						overflow: hidden;
						word-wrap: break-word;
						padding-bottom: 0;
					}
					.middle {
						display: flex;
						align-items: center;
						justify-content: center;
						height: 100%;
					}
				}
			}
		}
		.course_detail {
			padding: 0 20px;
			/deep/ p {
				font-size: 14px;
				color: #5D646E;
				line-height: 20px;
				img {
					display: block;
					width: 100%;
					height: 100%;
				}
			}
		}
	}
</style>


// WEBPACK FOOTER //
// src/components/views/TeachClass/components/courseInformation.vue